<template>
  <div class="steps-rating-modal">
    <Modal
      :active="active"
      name="StepsRatingModal"
      :class="{
        'for-mobile-app': isMobileApp,
      }"
      :title="title"
      :subtitle="subtitle"
      :img="image"
      :closable="true"
      @close="closeStepsRatingModal"
    >

      <div v-if="!isMobileApp || showBack" class="steps-rating-modal__back">
        <Button
          variant="secondary"
          :size="$root.isMobile ? 'sm' : 'lg'"
          shape="circle"
          iconLeft="left"
          mobile
          @click="closeStepsRatingModal"
        />
      </div>
      <!-- <div v-if="!isMobileApp || showBack" class="steps-rating-modal__share">
        <Button
          variant="secondary"
          :size="$root.isMobile ? 'sm' : 'lg'"
          shape="circle"
          iconLeft="upload"
          mobile
        />
      </div> -->

      <!-- Основной контейнер -->
      <div class="steps-rating-modal__container">
        <!-- Вкладки -->
        <div class="steps-rating-modal__tabs">
          <Tabs :items="tabs" :activeItem="selectedTab" @changed="changeTab" />
        </div>
        <div class="steps-rating-modal__divider"></div>
        <div v-if="selectedTab === 0">
          <div class="steps-rating-modal__content">
            Правила
          </div>
        </div>
        <div v-if="selectedTab === 1">
          <div class="steps-rating-modal__content">
            Награды
          </div>
        </div>
        <div v-if="selectedTab === 2">
          <div class="steps-rating-modal__tabs-period">
            <div
              @click="changePeriod('Daily')"
              class="steps-rating-modal__tabs-period__item"
              :class="{ 'steps-rating-modal__tabs-period__item--active': selectedPeriod === 'Daily' }"
            >
              День
            </div>
            <div
              @click="changePeriod('Weekly')"
              class="steps-rating-modal__tabs-period__item"
              :class="{ 'steps-rating-modal__tabs-period__item--active': selectedPeriod === 'Weekly' }"
            >
              Неделя
            </div>
            <div
              @click="changePeriod('Monthly')"
              class="steps-rating-modal__tabs-period__item"
              :class="{ 'steps-rating-modal__tabs-period__item--active': selectedPeriod === 'Monthly' }"
            >
              Месяц
            </div>
          </div>
          <div class="steps-rating-modal__content">
            <div v-if="selectedPeriod === 'Daily'">
              <div class="steps-rating-modal__date">
                <Button
                  @click="changeDay('prev')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="left"
                  :disabled="isPrevDisabled"
                />
                <div class="steps-rating-modal__date-label">{{ formatDay }}</div>
                <Button
                  @click="changeDay('next')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="right"
                  :disabled="isNextDisabled"
                />
              </div>
              <div v-if="ratingItems.length > 0" class="steps-rating-modal__entries">
                Показаны {{ displayRangeStart }}–{{ displayRangeEnd }} из {{ totalItems }} записей
              </div>
            </div>

            <div v-if="selectedPeriod === 'Weekly'">
              <div class="steps-rating-modal__date">
                <Button
                  @click="changeWeek('prev')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="left"
                  :disabled="isPrevDisabled"
                />
                <div class="steps-rating-modal__date-label">
                  {{ formattedWeekRange }}
                </div>
                <Button
                  @click="changeWeek('next')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="right"
                  :disabled="isNextDisabled"
                />
              </div>
              <div v-if="ratingItems.length > 0" class="steps-rating-modal__entries">
                Показаны {{ displayRangeStart }}–{{ displayRangeEnd }} из {{ totalItems }} записей
              </div>
            </div>

            <div v-if="selectedPeriod === 'Monthly'">
              <div class="steps-rating-modal__date">
                <Button
                  @click="changeMonth('prev')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="left"
                  :disabled="isPrevDisabled"
                />
                <div class="steps-rating-modal__date-label">{{ formattedMonthRange }}</div>
                <Button
                  @click="changeMonth('next')"
                  class="steps-rating-modal__date-button"
                  variant="clear"
                  shape="circle"
                  size="lg"
                  iconLeft="right"
                  :disabled="isNextDisabled"
                />
              </div>
              <div v-if="ratingItems.length > 0" class="steps-rating-modal__entries">
                Показаны {{ displayRangeStart }}–{{ displayRangeEnd }} из {{ totalItems }} записей
              </div>
            </div>
            <div>
              <div class="steps-rating-modal__table">
                <table>
                  <tr
                    v-for="(item, i) in ratingItems"
                    :key="i"
                    class="steps-rating-modal__rating-item"
                    :class="{ 'steps-rating-modal__rating-item--active': item.isCurrentParticipant === true }"
                  >
                    <td class="steps-rating-modal__rating-item__number">{{ item.position }}</td>
                    <td class="steps-rating-modal__rating-item__name">{{ item.lastName }} {{ item.firstName }}</td>
                    <td class="steps-rating-modal__rating-item__value">
                      <div>
                        {{ item.steps }}<img :src="stepImage" width="18" height="18"/>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
                <Button
                  v-if="ratingItems.length < totalItems && currentPage !== totalPages"
                  variant="secondary"
                  size="md"
                  mobile
                  :wide="true"
                  class="steps-rating-modal__more"
                  @click="onMore"
                >
                  Показать ещё
                </Button>
                <Pagination
                  v-if="totalItems > 10"
                  :currentPage="currentPage"
                  :totalPages="totalPages"
                  class="steps-rating-modal__pagination"
                  @prev-page="onChangePage(currentPage - 1)"
                  @next-page="onChangePage(currentPage + 1)"
                  @go-page="onChangePage"
                ></Pagination>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import StepRewardImg from '../../assets/img/step-reward.png';
import StepImage from '../../assets/icons/steps.svg';
import Pagination from '../Pagination/Pagination.vue';

export default {
  name: 'StepsRatingModal',
  components: {
    Pagination,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      title: '',
      subtitle: 'Мои шаги',
      image: StepRewardImg,
      stepImage: StepImage,
      isTeam: false,
      isMobileApp: false,
      tabs: [
        { title: 'Правила', enabled: false },
        { title: 'Награды', enabled: false },
        { title: 'Рейтинг', enabled: true },
      ],
      selectedTab: 2,
      showBack: false,
      selectedPeriod: 'Daily',
      ratingItems: [],
      showItemsCount: 10,
      offset: 0,
      currentPage: 1,
      totalItems: 0,
      currentDay: dayjs().format('YYYY-MM-DD'),
      usingPagination: true,
      showItemsOffsetForMore: 0,
    };
  },
  computed: {
    ...mapGetters('steps', ['ratings']),
    ...mapGetters('user', ['profile']),
    displayRangeStart() {
      if (this.usingPagination) {
        return (this.currentPage - 1) * this.showItemsCount + 1;
      }
      return ((this.offset + this.showItemsCount) - this.ratingItems.length) + 1;
    },
    displayRangeEnd() {
      if (this.usingPagination) {
        const end = this.currentPage * this.showItemsCount;
        return end > this.totalItems ? this.totalItems : end;
      }
      return this.offset + this.showItemsCount;
    },
    currentPageDisplay() {
      if (this.usingPagination) {
        return this.currentPage;
      }
      // виртуальная страница (необязательно)
      return Math.ceil(this.ratingItems.length / this.showItemsCount);
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.showItemsCount);
    },
    profileCreatedDate() {
      return this.profile?.createdOn ? dayjs(this.profile.createdOn) : null;
    },
    isPrevDisabled() {
      if (!this.profileCreatedDate) return false;
      if (this.selectedPeriod === 'Daily') {
        return dayjs(this.currentDay).subtract(1, 'day').isBefore(this.profileCreatedDate, 'day');
      }
      if (this.selectedPeriod === 'Weekly') {
        return this.startOfWeek.subtract(1, 'week').isBefore(this.profileCreatedDate, 'day');
      }
      if (this.selectedPeriod === 'Monthly') {
        return this.startOfMonth.subtract(1, 'month').isBefore(this.profileCreatedDate, 'day');
      }
      return false;
    },
    isNextDisabled() {
      if (this.selectedPeriod === 'Daily') {
        return dayjs(this.currentDay).add(1, 'day').isAfter(dayjs(), 'day');
      }
      if (this.selectedPeriod === 'Weekly') {
        return this.startOfWeek.add(1, 'week').isAfter(dayjs(), 'day');
      }
      if (this.selectedPeriod === 'Monthly') {
        return this.startOfMonth.add(1, 'month').isAfter(dayjs(), 'day');
      }
      return false;
    },
    formatDay() {
      return dayjs(this.currentDay).format('D MMMM');
    },
    startOfWeek() {
      return dayjs(this.currentDay).startOf('isoWeek');
    },
    endOfWeek() {
      return this.startOfWeek.add(6, 'day');
    },
    startOfWeekFormatted() {
      return this.startOfWeek.format('YYYY-MM-DD');
    },
    endOfWeekFormatted() {
      return this.endOfWeek.format('YYYY-MM-DD');
    },
    formattedWeekRange() {
      return `${this.startOfWeek.format('DD.MM')} – ${this.endOfWeek.format('DD.MM YYYY')}`;
    },
    startOfMonth() {
      return dayjs(this.currentDay).startOf('month');
    },
    endOfMonth() {
      return this.startOfMonth.endOf('month');
    },
    startOfMonthFormatted() {
      return this.startOfMonth.format('YYYY-MM-DD');
    },
    endOfMonthFormatted() {
      return this.endOfMonth.format('YYYY-MM-DD');
    },
    formattedMonthRange() {
      return this.startOfMonth.format('MMMM YYYY');
    },
  },
  methods: {
    ...mapActions('steps', ['getRatings']),
    closeStepsRatingModal() {
      this.resetState();
      setTimeout(() => {
        this.selectedPeriod = 'Daily';
      }, 250);
      this.$emit('close');
    },
    loadData(reset = true) {
      let dateFrom = null;
      let periodType = '';

      if (this.selectedPeriod === 'Daily') {
        dateFrom = this.currentDay;
        periodType = 'Daily';
      } else if (this.selectedPeriod === 'Weekly') {
        dateFrom = this.startOfWeekFormatted;
        periodType = 'Weekly';
      } else if (this.selectedPeriod === 'Monthly') {
        dateFrom = this.startOfMonthFormatted;
        periodType = 'Monthly';
      }

      this.getRatings({
        dateFrom,
        periodType,
        offset: this.offset,
        count: this.showItemsCount,
      }).then(() => {
        if (this.ratings) {
          if (reset) {
            this.ratingItems = this.ratings.values;
          } else {
            this.ratingItems = [...this.ratingItems, ...this.ratings.values];
          }
          this.totalItems = this.ratings.total;
        }
      });
    },
    async onMore() {
      if (this.ratingItems.length >= this.totalItems) return;

      this.offset += this.showItemsCount;
      this.currentPage = Math.floor(this.offset / this.showItemsCount) + 1;
      this.usingPagination = false;

      await this.loadData(false);
    },
    changePeriod(period) {
      this.currentDay = dayjs().format('YYYY-MM-DD');
      this.selectedPeriod = period;
      this.resetState();
    },
    changeDay(direction) {
      this.currentDay = dayjs(this.currentDay)[direction === 'prev' ? 'subtract' : 'add'](1, 'day').format('YYYY-MM-DD');
      this.resetState();
    },
    changeWeek(direction) {
      this.currentDay = this.startOfWeek[direction === 'prev' ? 'subtract' : 'add'](1, 'week').format('YYYY-MM-DD');
      this.resetState();
    },
    changeMonth(direction) {
      this.currentDay = this.startOfMonth[direction === 'prev' ? 'subtract' : 'add'](1, 'month').format('YYYY-MM-DD');
      this.resetState();
    },
    resetState() {
      this.currentPage = 1;
      this.offset = 0;
      this.usingPagination = true;
      this.loadData(true);
    },
    changeTab(tabIndex) {
      this.selectedTab = tabIndex;
    },
    onChangePage(page) {
      if (this.currentPage === page) return;
      this.currentPage = page;
      this.offset = (page - 1) * this.showItemsCount;
      this.usingPagination = true;
      this.loadData(true);
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="scss" scoped>
  @import './StepsRatingModal';
</style>
